import { render, staticRenderFns } from "./TempGroupModal.vue?vue&type=template&id=3054c12f&"
import script from "./TempGroupModal.vue?vue&type=script&lang=js&"
export * from "./TempGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports